import styled from 'styled-components';

export const Container = styled.main`
  width: 100%;
  margin: 0 auto;
  padding-bottom: 96px;
`;

export const Credits = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 0 auto;
  text-align: center;
  font-size: 18px;
  line-height: 26px;
  text-transform: uppercase;
  padding-top: 40px;
  position: relative;
  margin-top: 4%;

  :before {
    content: '';
    display: block;
    width: 80px;
    height: 1px;
    background-color: #000;
    position: absolute;
    top: 0;
  }
`;
